import SendQuoteStatusRequest from './SendQuoteStatusRequest';

export default SendQuoteStatusRequest;
